import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Link,
  Typography,
} from '@mui/material';
import { FC } from 'react';
import { BrandKey } from '../../../__generated__/queries-web';
import { getTitleFromBrandKey } from '../../../utils/brands';
import { pluralizeText } from '../../../utils/pluralizeText';
import {
  AUTHOR_NAME_UPDATE_INTRO,
  AUTHOR_NAME_UPDATE_LIMIT,
  AUTHOR_NAME_UPDATE_QUESTION,
  ONE_TEAM_EMAIL,
} from './constants';

export interface AuthorArticleUsage {
  id: string;
  brandKey: BrandKey;
  articleCount: number;
}

interface NameConfirmDialogProps {
  isOpen: boolean;
  isForbidden: boolean;
  usages: AuthorArticleUsage[];
  onValidate: () => void;
  onCancel: () => void;
}

const getBrandLabel = (brandKey: BrandKey) =>
  (getTitleFromBrandKey(brandKey) ?? brandKey).toUpperCase();

export const NameConfirmDialog: FC<NameConfirmDialogProps> = ({
  isOpen,
  isForbidden,
  usages,
  onValidate,
  onCancel,
}) => (
  <Dialog
    fullWidth
    maxWidth="sm"
    open={isOpen}
    onClose={onCancel}
    data-testid="authorNameConfirmDialog"
  >
    <DialogContent>
      {isForbidden ? (
        <Typography>
          La modification de cet auteur n'est pas possible car il est utilisé
          sur au moins {AUTHOR_NAME_UPDATE_LIMIT} articles. Veuillez contacter
          l'équipe ONE (
          <Link href={`mailto:${ONE_TEAM_EMAIL}`}>{ONE_TEAM_EMAIL}</Link>) pour
          plus d'informations.
        </Typography>
      ) : (
        <>
          <Typography>{AUTHOR_NAME_UPDATE_INTRO}</Typography>
          <Typography component="ul" sx={{ pl: 2.5, my: 1.5 }}>
            {usages.map(({ id, brandKey, articleCount }) => (
              <li key={id}>
                {pluralizeText(articleCount, 'article', true)} sur{' '}
                {getBrandLabel(brandKey)}
              </li>
            ))}
          </Typography>
          <Typography>{AUTHOR_NAME_UPDATE_QUESTION}</Typography>
        </>
      )}
    </DialogContent>
    <DialogActions>
      <Button
        data-testid="authorNameConfirmCancelBtn"
        variant="outlined"
        onClick={onCancel}
      >
        Annuler
      </Button>
      <Button
        data-testid="authorNameConfirmValidateBtn"
        variant="contained"
        disabled={isForbidden}
        onClick={onValidate}
      >
        Valider
      </Button>
    </DialogActions>
  </Dialog>
);
